import { ChangeDetectionStrategy, Component, OnInit, WritableSignal, signal } from '@angular/core';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { nameHelper } from 'lib/helpers/name-helper.js';
import { ITable } from 'lib/ui/table/index.js';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

@Component({
    selector: 'mod-list-admin-user-templates',
    templateUrl: './list-admin-user-templates.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ListAdminUserTemplatesComponent extends TypeCoreComponent implements OnInit {
	public readonly table: WritableSignal<ITable<UserDb.IUserItem> | undefined> = signal(undefined);

	constructor() {
		super();

		this.dataInit = () => {
			this.initUserTemplates();
		};
	}

	private initUserTemplates(): void {
		super.subscribeToObservable(
			this.dependencies.httpService.listCustom<UserDb.IUserItem>('user', 'listUsertemplates').pipe(
				map((response) => {
					this.table.set({
						itemType: 'User',
						noItemsText: {
							noItems: `There are no user templates`,
							noFilteredItems: `No demo users match your filter`
						},
						search: {
							type: 'local'
						},
						items: response.data,
						avatar: (item) => {
							return {
								name: item.email,
								image: item.avatar
							};
						},
						id: (item) => item.id,
						title: {
							title: 'User templates',
							value: (item) => nameHelper.getUserName(item.email, item.firstName, item.lastName)
						},
						subtitle: (item) => item.email,
						fields: [],
						mainItemClick: (item) => {
							this.dependencies.dialogService.openTextDialog({
								title: `${item.fullName}`,
								code: { code: JSON.stringify(item), format: 'json' }
							});
						}
					});
				})
			)
		);
	}
}
